require('./bootstrap');

// window.Vue = require('vue');
// import store from './store';

require('./lozad');
require('./video');
require('./like');
require('./thumbnail');
require('./formControls');
require('./checkout');
require('./wow');
require('./disclaimer');
window.snackbar = require('./snackbar').default;

window.addEventListener('contextmenu', (event) => {
    event.preventDefault()
});
window.addEventListener('load', () => {
    $('[data-toggle="tooltip"]').tooltip()
});


// const app = new Vue({
//     store,
//     el: '#app',
// });
